import { IQueriesListItem } from '../queriesList.interface';

type TQueriesListItemWithDomainStr = Omit<IQueriesListItem, 'domains'> & {
  domains: string;
};

/**
 * Iterates the questionsList and sorted the sharedUsers[] by user firstName
 * @param questionsList
 * @returns IQueriesListItem[]
 */
export const transformQuestionList = (
  questionsList: TQueriesListItemWithDomainStr[]
): IQueriesListItem[] => {
  let sortedSharedUsersQuestionList: IQueriesListItem[] = [];

  try {
    sortedSharedUsersQuestionList = questionsList.reduce((acc: IQueriesListItem[], query) => {
      return [
        ...acc,
        {
          ...query,

          // sort the domain names alphabetically
          domains: (query?.domains || '')
            .split(',')
            .sort((a: string, b: string) =>
              a?.toLocaleLowerCase()?.localeCompare(b?.toLocaleLowerCase())
            ),

          // sort the sharedUsers list alpha by firstName
          sharedUsers: (query?.sharedUsers || []).sort((a, b) => {
            return a?.firstName?.toLowerCase()?.localeCompare(b?.firstName?.toLowerCase());
          }),
        },
      ];
    }, []);
  } catch (err) {
    console.warn('Error transforming the questions list', questionsList, err);
    // If an error occurs, return the original list with domains split into an array
    sortedSharedUsersQuestionList = questionsList.map((item) => ({
      ...item,
      domains: item.domains.split(','),
    }));
  }

  return sortedSharedUsersQuestionList;
};
